import React, { Component } from "react";
import { connect } from "react-redux";
import { saveLike, addToFavorite } from "Thunks";
import styles1 from "./Social.local.scss";
import styles2 from "./SocialLarge.local.scss";

import SocialComponent from "./SocialComponent";
import SocialLargeComponent from "./SocialLargeComponent";

export class SocialContainer extends Component {
  state = {
    countLike: this.props.resource.countLikes,
    countDislike: this.props.resource.countDislikes
  };

  componentDidUpdate(prevProps) {
    if (prevProps.resource !== this.props.resource) {
      this.setState({
        countLike: this.props.resource.countLikes,
        countDislike: this.props.resource.countDislikes
      });
    }
  }

  handleClickFav = (fromLarge, e) => {
    e.preventDefault();
    const { addToFavorite, loggedAs, type, resource } = this.props;

    if (loggedAs && loggedAs === "GUEST") {
      return null;
    }
    const targ = e.currentTarget.classList;
    const styles = !fromLarge ? styles1 : styles2;

    if (targ.contains(styles.socialActive)) {
      targ.remove(styles.socialActive);
    } else {
      targ.add(styles.socialActive);
    }

    addToFavorite({ id: resource.id, objectType: type ? type : "MEDIA" });
    return false;
  };

  handleAddLike = (isLike, fromLarge, e) => {
    e.preventDefault();
    const { saveLike, loggedAs, type, resource } = this.props;
    const { countLike, countDislike } = this.state;
    if (loggedAs && loggedAs === "GUEST") {
      return null;
    }
    const styles = !fromLarge ? styles1 : styles2;
    const target = e.currentTarget.classList;

    if (target.contains(styles.socialActive)) {
      target.remove(styles.socialActive);

      if (isLike) {
        this.setState({ countLike: countLike - 1 });
      } else {
        this.setState({ countDislike: countDislike - 1 });
      }
    } else {
      target.add(styles.socialActive);
      if (isLike) {
        this.setState({ countLike: countLike + 1 });

        const sibling = e.currentTarget.nextSibling.classList;
        if (sibling.contains(styles.socialActive)) {
          sibling.remove(styles.socialActive);
          this.setState({ countDislike: countDislike - 1 });
        }
      } else {
        this.setState({ countDislike: countDislike + 1 });

        const sibling = e.currentTarget.previousSibling.classList;
        if (sibling.contains(styles.socialActive)) {
          sibling.remove(styles.socialActive);
          this.setState({ countLike: countLike - 1 });
        }
      }

      /*const socialLikes = e.currentTarget.parentNode.getElementsByClassName(
        styles.socialLike
      );

      let activated = null;
      for (let i = 0; i < socialLikes.length; i++) {
        if (socialLikes.item(i).classList.contains(styles.socialActive)) {
          activated = socialLikes.item(i).classList;
          break;
        }
      }
      if (activated) {
        activated.remove(styles.socialActive);
        if (isLike) {
          this.setState({
            countLike: countLike + 1,
            countDislike: countDislike - 1
          });
        } else {
          this.setState({
            countLike: countLike - 1,
            countDislike: countDislike + 1
          });
        }
      } else {
        if (isLike) {
          this.setState({ countLike: countLike + 1 });
        } else {
          this.setState({ countDislike: countDislike + 1 });
        }
      }*/
    }

    saveLike({ type, id: resource.id, isLike });
    return false;
  };

  render() {
    const { community, resource, fromViewer, customStyle } = this.props;
    const { countLike, countDislike } = this.state;

    if (fromViewer) {
      return (
        <SocialLargeComponent
          resource={resource}
          community={community}
          countLike={countLike}
          countDislike={countDislike}
          onClickFav={this.handleClickFav.bind(this)}
          onClickLike={this.handleAddLike}
          customStyle={`customStyle${customStyle || 1}`}
        />
      );
    }
    return (
      <SocialComponent
        resource={resource}
        community={community}
        countLike={countLike}
        countDislike={countDislike}
        onClickFav={this.handleClickFav.bind(this)}
        onClickLike={this.handleAddLike}
        customStyle={`customStyle${customStyle || 1}`}
      />
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  loggedAs: state.auth.loggedAs
});

const mapDispatchToProps = dispatch => ({
  saveLike: data => dispatch(saveLike(data)),
  addToFavorite: data => dispatch(addToFavorite(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SocialContainer);



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/Social/SocialContainer.js